import React, { Component } from 'react'
import { Link, browserHistory } from 'react-router'
import URLS from 'constant/URLS'
import FontAwesome from 'react-fontawesome'

class Header extends Component {
    constructor() {
        super()
        this.state = {
            navOpen: false
        }
    }

    isActiveNav(urls) {
        if (!browserHistory) return
        return urls.indexOf(browserHistory.getCurrentLocation().pathname) >= 0 ? 'active' : null
    }
    
    openNav() {
        this.setState({
            navOpen: !this.state.navOpen
        })
    }

    render() {
        return (
            <header id='topnav'>
                <div className='topbar-main'>
                    <div className='container'>
                        <div className='topbar-left'>
                            <Link to={ URLS.home } className='logo'>
                                <span>Beeo<span>App </span></span>
                            </Link>
                        </div>
                        <div className='navbar-custom navbar-left'>
                            <div className='menu-item'>
                                <a className={ `navbar-toggle ${this.state.navOpen ? "open": ""}` }>
                                <div className='lines' onClick={ this.openNav.bind(this) }>
                                    <span />
                                    <span />
                                    <span />
                                </div>
                                </a>
                            </div>
                            <div id='navigation' style={ { display: this.state.navOpen ? "block" : "none" } }>
                                <ul className='navigation-menu'>
                                    <li className={ this.isActiveNav([URLS.home]) }>
                                        <Link to={ URLS.home }>
                                            <span><FontAwesome name='dashboard' /></span>
                                            <span> Dashboard </span>
                                        </Link>
                                    </li>
                                    {
                                        this.props.user && !this.props.user.limited &&
                                        <li className={ this.isActiveNav([URLS.hives.index]) }>
                                            <Link to={ URLS.hives.index }>
                                                <span><FontAwesome name='archive' /></span>
                                                <span> Ruches </span>
                                            </Link>
                                        </li>
                                    }
                                    {
                                        this.props.user && !this.props.user.limited &&
                                        <li className={ this.isActiveNav([URLS.client.index]) }>
                                            <Link to={ URLS.client.index }>
                                                <span><FontAwesome name='user' /></span>
                                                <span> Clients </span>
                                            </Link>
                                        </li>
                                    }
                                    {
                                        this.props.user && !this.props.user.limited &&
                                        <li className={ this.isActiveNav([URLS.users.index]) }>
                                            <Link to={ URLS.users.index }>
                                                <span><FontAwesome name='users' /></span>
                                                <span> Utilisateurs </span>
                                            </Link>
                                        </li>
                                    }
                                </ul>
                            </div>
                        </div>
                        <div className='navbar-custom navbar-right'>
                                <ul className='nav navbar-nav navbar-right pull-right'>
                                    <li>
                                        <a onClick={ this.props.logout }>
                                            <span><FontAwesome name='power-off' /></span>
                                            <span> Logout </span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                </div>
            </header>

        )
    }
}

export default Header


// WEBPACK FOOTER //
// ./src/client/features/app/components/Header.jsx